import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSolutionCategoryPageLink } from "template-store/services/solution-links-service";
import Tag from "@mondaydotcomorg/monday-ui-components/dist/Tag";
import { StyledTemplateHeader } from "./template-header.scss";
const TemplateHeader = (props)=>{
    const { templateName, templateCategoriesData, categoriesPrefixText } = props;
    const renderCategories = ()=>{
        return templateCategoriesData.map((categoryData, index)=>{
            return /*#__PURE__*/ _jsx("div", {
                className: "category-wrapper",
                children: /*#__PURE__*/ _jsx(Tag, {
                    tagName: categoryData.label,
                    tagLink: getSolutionCategoryPageLink(categoryData.value)
                })
            }, index);
        });
    };
    return /*#__PURE__*/ _jsx(StyledTemplateHeader, {
        className: "template-header",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "template-data-wrapper",
            children: [
                /*#__PURE__*/ _jsxs("h1", {
                    className: "template-name",
                    children: [
                        " ",
                        templateName,
                        " Template"
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "template-details-wrapper",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "template-categories",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "category-prefix-text",
                                children: categoriesPrefixText
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "categories-wrapper",
                                children: [
                                    " ",
                                    renderCategories()
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
TemplateHeader.defaultProps = {};
export default TemplateHeader;
